import {Component, Input, OnInit} from '@angular/core';
import {IReview} from "../interface/review";
import {Router} from "@angular/router";
import {ReviewTransmissionService} from "../../raintree/transmission/review-transmission.service";

@Component({
	selector: 'fb-review-list',
	templateUrl: './review-list.component.html',
	styleUrls: ['./review-list.component.scss']
})
export class ReviewListComponent implements OnInit {

	@Input()
	public productId: number = 0;
	private pageNumber: number = 0;
	private pageSize: number = 10;

	protected reviewList: IReview[] = [];

	constructor(
		private _router: Router,
		private _api: ReviewTransmissionService
	) {
	}

	ngOnInit(): void {
		this.resolveReviews();
	}

	private resolveReviews() {
		this.productId === 0 ? this.resolveAllReviewList() : this.resolveProductSpecificReviewList();
	}

	private resolveProductSpecificReviewList(): void {
		this._api.getProductSpecificReviewList(
			this.productId,
			this.pageNumber,
			5,
			() => {
			},
			(response: IReview[]) => {
			},
			(response: IReview[]) => {
				this.reviewList = response;
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	private resolveAllReviewList(): void {
		this._api.getReviewList(
			this.pageNumber,
			this.pageSize,
			() => {
			},
			(response: IReview[]) => {
			},
			(response: IReview[]) => {
				this.reviewList = [...this.reviewList, ...response];
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	protected onViewAll(): void {
		this._router.navigateByUrl('review').then(r => {
		})
	}

	protected onViewMore(): void {
		this.pageNumber++;
		this.resolveAllReviewList();
	}
}
